import {
  Component,
  h,
  Prop,
  ComponentInterface,
  Element,
  Method,
  Host,
} from '@stencil/core';

@Component({
  tag: 'signet-modal',
  styleUrl: 'signet-modal.scss',
})
export class SignetModal implements ComponentInterface {
  $overlay: HTMLSignetOverlayElement;
  titleId = `modal_title_${modalIds++}`;

  @Element() $el: HTMLElement;

  @Prop() modalTitle: string;
  @Prop({ mutable: true }) preventClose = false;
  @Prop() size: 'sm' | 'md' | 'lg' = 'md';
  @Prop() openModal = false;

  @Method()
  async show() {
    await this.$overlay.show();
  }

  @Method()
  async hide() {
    await this.$overlay.hide();
  }

  render() {
    return (
      <Host class="signet-modal">
        <signet-overlay
          title-id={this.titleId}
          ref={(el) => (this.$overlay = el)}
          prevent-close={this.preventClose}
          open-modal={this.openModal}
        >
          <div class={`modal-wrapper size-${this.size}`}>
            <header class="modal-header">
              <h3 class="modal-title" id={this.titleId}>
                {this.modalTitle}
              </h3>
              {!this.preventClose && (
                <div class="modal-close">
                  <span onClick={() => this.hide()} class="text">
                    <signet-icon icon="close" class="icon" />
                  </span>
                </div>
              )}
            </header>
            <div class="modal-content">
              <slot />
            </div>
          </div>
        </signet-overlay>
      </Host>
    );
  }
}

let modalIds = 0;
